import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import PinkLightButton from "../../../components/customButtons/PinkLightButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CustomPopup from "../../../components/customPopup/CustomPopup";
import AddNewAddress from "./AddNewAddress";
import SussceeffulyMessageScreen from "../../../components/customPopup/SussceeffulyMessageScreen";
import { useLocation } from "react-router-dom";

export default function NoAddressScreen() {
  const [OpenNewAddress, SetOpenNewAddress] = useState(false);
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const location = useLocation();

  const handleOpenAddressPopup = () => {
    SetOpenNewAddress(true);
  };

  const handleCloseAddressPopup = () => {
    SetOpenNewAddress(false);
  };

  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        flexDirection="column"
        gap={3}
        px={{ xs: 2, sm: 5, md: 7, lg: 15 }}
      >
        <Box width={64} height={64}>
          <img src="/newdashboard/Checkout/Group 1171283823.png" />
        </Box>
        <Typography
          textAlign="start"
          color="#9D0385"
          fontFamily="Inter"
          fontSize="18px"
          lineHeight="100%"
          letterSpacing="0px"
          fontStyle="normal"
          style={{ fontWeight: 700 }}
        >
          No Address Saved
        </Typography>

        <Typography
          textAlign="center"
          color="#666666"
          fontFamily="Inter"
          fontSize="16px"
          lineHeight="1.4"
          letterSpacing="0px"
          fontStyle="normal"
          style={{ fontWeight: 400 }}
        >
          You need to add a billing address before you can complete your
          purchase. This address will be used for order confirmation and billing
          purposes.
        </Typography>

        <PinkLightButton
          onClick={handleOpenAddressPopup}
          buttonTitle="Add Address"
          startIcon={<AddCircleIcon />}
        />
      </Box>

      <CustomPopup
        handleClose={handleCloseAddressPopup}
        component={
          <AddNewAddress
            handleClose={handleCloseAddressPopup}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
            setSuccessTitle="Address Added Successfully !!"
          />
        }
        open={OpenNewAddress}
        subtitle=""
        maxWidth="sm"
      />

      <SussceeffulyMessageScreen
        text="Address Added Successfully !!"
        subText=""
        buttonTitle="Thanks, Got it"
        navigateLink="/test-prep/checkout"
        currentLink={location.pathname}
        handleClose={handleCloseSuccessPopup}
        open={openSuccesPopup}
      />
    </>
  );
}
